import { Box, Button, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import theme from 'src/theme'

export default (): ReactElement => {
  let navigate = useNavigate()

  return (
    <Box component="main" sx={{ m: -3, backgroundColor: 'background.default' }}>
      <Box className="flex items-center justify-center">
        <Box
          sx={{
            flex: '1 0 200px',
            maxWidth: 400,
            boxShadow: `0 0 200px 0 ${theme.palette.background.paper}`,
          }}
        >
          <img
            style={{ width: '100%', height: 'auto' }}
            src="/404-error.png"
            alt="404 error"
          />
        </Box>
      </Box>
      <Box className="flex flex-col items-center mt-2">
        <Typography component="h1" className="my-2">
          This page does not exist.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/self-paced')}>
          Return to Home Page
        </Button>
      </Box>
    </Box>
  )
}
